module.exports = __webpack_public_path__ + "static/img/3.63ddb2e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/eng/3.png
// module id = U47i
// module chunks = 0